import { useState } from "react";

/**
 * Collapsed list of pages Claude marked as "already optimized." Shown below
 * the experiments so users can see their whole site was audited — not just
 * the ones that needed fixes.
 */
export default function GoodPagesSection({ goodPages = [] }) {
  const [open, setOpen] = useState(false);
  if (goodPages.length === 0) return null;

  return (
    <section className="bg-white border border-slate-200 rounded-xl overflow-hidden mt-6">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-3 px-5 py-4 hover:bg-slate-50 cursor-pointer text-left"
      >
        <span className="w-1 self-stretch rounded-full bg-emerald-400" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-base">✅</span>
            <h3 className="text-base font-extrabold text-slate-900 uppercase tracking-wide">
              Already well-optimized
            </h3>
            <span className="text-[11px] font-bold px-2 py-0.5 rounded border border-emerald-400 bg-emerald-50 text-emerald-900">
              {goodPages.length}
            </span>
          </div>
          <p className="text-xs text-slate-500 mt-1">
            {goodPages.length} page{goodPages.length === 1 ? "" : "s"} passed
            the audit — no meaningful changes needed. Click to see why.
          </p>
        </div>
        <svg
          width="14" height="14" viewBox="0 0 14 14" fill="none"
          className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`}
          aria-hidden="true"
        >
          <path d="M3 5l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {open && (
        <ul className="border-t border-slate-100 divide-y divide-slate-100">
          {goodPages.map((g, i) => (
            <li key={g.url + i} className="px-5 py-3 text-sm">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-xs text-emerald-600">✓</span>
                <span className="text-xs font-mono text-indigo-600 break-all flex-1 min-w-0">{g.url}</span>
                {g.track && (
                  <span className="text-[10px] uppercase tracking-wide font-bold px-1.5 py-0.5 rounded bg-slate-100 text-slate-600">
                    {g.track}
                  </span>
                )}
              </div>
              {g.reason && (
                <div className="text-xs text-slate-600 mt-1 ml-5">{g.reason}</div>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
